import { BountyService } from './../../services/bounty.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Bounty } from '../../interfaces/Bounty';

@Component({
  selector: 'app-claim-bounty-form',
  templateUrl: './claim-bounty-form.component.html',
  styleUrls: ['./claim-bounty-form.component.scss'],
})
export class ClaimBountyFormComponent implements OnInit {
  public isLoggedIn: boolean;
  public isVerified: boolean;
  public user: any;
  public submitting = false;
  public evidence: string;
  public errors: string[] = [];
  public success = false;

  @Input() bounty: Bounty;
  @Output() claimCreated = new EventEmitter<number>();

  constructor(private bountyService: BountyService) {
    const user: any = (<any>window).user;
    this.user = user;
    this.isLoggedIn = !!user;
    this.isVerified = user && user.osu_username_verified;
  }

  ngOnInit() {}

  async submitClaim() {
    this.submitting = true;
    this.errors = [];

    try {
      const { claim_id } = await this.bountyService.submitClaim(
        this.bounty.id,
        this.evidence,
      );
      this.success = true;
      this.claimCreated.next(claim_id);
    } catch (e) {
      if (e.error) {
        if (e.error.errors) {
          this.errors = <string[]>Object.values(e.error.errors).reduce(
            (acc: any[], curr: any[]) => {
              acc.push(...curr);

              return acc;
            },
            [],
          );
        } else if (e.error.error) {
          this.errors = [e.error.error];
        } else {
          this.errors = ['A server error occured'];
        }
      } else {
        this.errors = ['A server error occured'];
      }
    }

    this.submitting = false;
  }
}
